var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFooterIconStep2Middle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 81.51,
    height: 143.059,
    viewBox: "0 0 81.51 143.059",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1663",
    "data-name": "Group 1663",
    transform: "translate(-92.457 -876.109)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2453",
    "data-name": "Rectangle 2453",
    width: 81.51,
    height: 143.059,
    rx: 5,
    transform: "translate(92.457 876.109)",
    fill: "#005ae7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1662",
    "data-name": "Group 1662"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2456",
    "data-name": "Rectangle 2456",
    width: 11.644,
    height: 11.644,
    transform: "translate(109.755 892.744)",
    fill: "#f4f6f8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2460",
    "data-name": "Rectangle 2460",
    width: 11.644,
    height: 11.644,
    transform: "translate(109.755 911.042)",
    fill: "#f4f6f8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2457",
    "data-name": "Rectangle 2457",
    width: 11.644,
    height: 11.644,
    transform: "translate(128.054 892.744)",
    fill: "#f4f6f8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2459",
    "data-name": "Rectangle 2459",
    width: 11.644,
    height: 11.644,
    transform: "translate(128.054 911.042)",
    fill: "#f4f6f8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2467",
    "data-name": "Rectangle 2467",
    width: 11.644,
    height: 11.644,
    transform: "translate(145.688 911.042)",
    fill: "#f4f6f8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2468",
    "data-name": "Rectangle 2468",
    width: 11.644,
    height: 11.644,
    transform: "translate(145.688 929.34)",
    fill: "#f4f6f8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2469",
    "data-name": "Rectangle 2469",
    width: 11.644,
    height: 11.644,
    transform: "translate(145.688 947.638)",
    fill: "#f4f6f8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2458",
    "data-name": "Rectangle 2458",
    width: 11.644,
    height: 11.644,
    transform: "translate(145.688 892.744)",
    fill: "#f4f6f8"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterIconStep2Middle);
export default __webpack_public_path__ + "static/media/footer-icon-step2-middle.95e71d07.svg";
export { ForwardRef as ReactComponent };